/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import {ApplicationState} from './interfaces';
import {initialState as ui} from './reducerUI';
import {initialState as config} from './reducerConfig';
import {initialState as contact} from './reducerContact';
import {initialState as library} from './reducerLibrary';

const initialState : ApplicationState = {
   ui,
   config,
   contact,
   library
};

export default initialState;